import StatefulPageEdit from './StatefulPageEdit.container';

export default StatefulPageEdit;
